import React from 'react';
import { QuickMenuProps } from './QuickMenu.types';
import { adaptQuickMenuProps } from './QuickMenu.adapter';
import useQuickMenuLogic from './QuickMenuLogic';
import { ComponentRenderMode } from '../../../types/component-skin';
import './QuickMenu.css';

/**
 * 퀵 메뉴 컴포넌트
 * 최상위 카테고리들을 원형 아이콘으로 표시하는 네비게이션 컴포넌트
 */
const QuickMenu: React.FC<QuickMenuProps> = (props) => {
  // 속성 어댑터를 통해 props 변환
  const adaptedProps = adaptQuickMenuProps(props);
  const { id, style = {}, className = '', data } = adaptedProps;
  const { columnsPerRow, showCategoryName, showAllCategory, allCategoryGradientStart, allCategoryGradientEnd, allCategoryTextColor, imageSize, gap, hoverEffect } = data;
  
  // 비즈니스 로직 훅 사용
  const logic = useQuickMenuLogic(
    { componentProps: props.componentProps || {} } as any,
    (props.mode || 'preview') as ComponentRenderMode
  );
  
  const { displayItems, loading } = logic.data;
  const { handleItemClick } = logic.actions;
  
  // 로딩 중일 때
  if (loading) {
    return (
      <div className={`quick-menu-container ${className}`} style={style}>
        <div className="quick-menu-loading">카테고리를 불러오는 중...</div>
      </div>
    );
  }
  
  // 표시할 아이템이 없을 때
  if (displayItems.length === 0) {
    return (
      <div className={`quick-menu-container ${className}`} style={style}>
        <div className="quick-menu-empty">표시할 카테고리가 없습니다.</div>
      </div>
    );
  }
  
  // 동적 스타일 생성
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${columnsPerRow}, 1fr)`,
    gap: `${gap}px`,
    ...style
  };
  
  const itemStyle = {
    width: `${imageSize}px`,
    height: `${imageSize}px`
  };
  
  return (
    <div id={id} className={`quick-menu-container ${className}`} style={gridStyle}>
      {displayItems.map((item) => (
        <div
          key={item.id}
          className={`quick-menu-item ${hoverEffect ? 'hover-effect' : ''}`}
          onClick={() => handleItemClick(item)}
        >
          <div className="quick-menu-icon" style={itemStyle}>
            {item.id === 'all-category' ? (
              // 전체 카테고리를 위한 특별한 렌더링
              <div 
                className="quick-menu-all-category"
                style={{
                  background: allCategoryGradientStart === allCategoryGradientEnd 
                    ? allCategoryGradientStart 
                    : `linear-gradient(180deg, ${allCategoryGradientStart} 0%, ${allCategoryGradientEnd} 100%)`,
                  color: allCategoryTextColor
                }}
              >
                <span className="all-text">ALL</span>
              </div>
            ) : item.imageUrl ? (
              <img 
                src={item.imageUrl} 
                alt={item.categoryName}
                className="quick-menu-image"
              />
            ) : (
              <div className="quick-menu-placeholder">
                <i className="fas fa-image"></i>
              </div>
            )}
          </div>
          {showCategoryName && (
            <div className="quick-menu-label">{item.categoryName}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default QuickMenu;